import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DriveOnDisplayableTaskDto as DriveonTask } from '@/generated/model';
import { getTaskAddress } from '@/components/common/TaskHelper';
import { useNotificationContext } from '@/contexts/NotificationCtx';
import GoogleIcon from '@mui/icons-material/Google';
import AppleIcon from '@mui/icons-material/Apple';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';

import './MapAppPicker.css';

type MapAppPickerProps = {
  type: string;
  task: DriveonTask;
  onClose: () => void;
};

export function MapAppPicker({ type, task, onClose }: MapAppPickerProps) {
  const { t } = useTranslation();
  const ctxNotify = useNotificationContext();
  let query = '';

  switch (type) {
    case 'address': {
      const address = getTaskAddress(task);
      if (!address) {
        ctxNotify?.showNotification('error', t('mapAppPicker.noAddress'), undefined, 10);
        return undefined;
      }
      query = encodeURIComponent(address);
      break;
    }
    case 'gps': {
      const latitude = task.latitude;
      const longitude = task.longitude;
      if (!latitude || !longitude) {
        ctxNotify?.showNotification('error', t('mapAppPicker.noGps'), undefined, 10);
        return undefined;
      }
      query = encodeURIComponent(`${latitude},${longitude}`);
      break;
    }
  }

  const mapLinks = {
    google: `https://www.google.com/maps/search/?api=1&query=${query}`,
    apple: `https://maps.apple.com/?q=${query}`,
    waze: `https://waze.com/ul?q=${query}`,
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>
        <Stack direction={'row'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', size: 24 }}>{t('mapAppPicker.title')}</Typography>
          <IconButton>
            <CloseOutlined onClick={() => onClose()} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent className="content">
        <Stack className="button-group" gap={2}>
          <Button href={mapLinks.google} target="_blank" rel="noopener noreferrer" variant="contained"
            startIcon={<GoogleIcon />}
              sx={{ 
              margin: '1px',
              color: 'white', 
              backgroundColor: 'grey !important' }}
         >
            Google Maps
          </Button>
          <Button href={mapLinks.apple} target="_blank" rel="noopener noreferrer" variant="contained"
             startIcon={<AppleIcon />}
              sx={{ 
              margin: '1px',
              color: 'white', 
              backgroundColor: 'grey !important' }}
          >
            Apple Maps
          </Button>
          <Button href={mapLinks.waze} target="_blank" rel="noopener noreferrer" variant="contained"
           startIcon={<SentimentSatisfiedAltIcon />}
              sx={{ 
              margin: '1px',
              color: 'white', 
              backgroundColor: 'grey !important' }}
          >
            Waze
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
